exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3xe2ewgwH0qcv3Bgm0SMk_ {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n._3xe2ewgwH0qcv3Bgm0SMk_ ._2_Zi8DWZy7A1y8z-W0MQpE {\n  margin-left: 5px;\n}\n", ""]);
// Exports
exports.locals = {
	"selectError": "_3xe2ewgwH0qcv3Bgm0SMk_",
	"errorMsg": "_2_Zi8DWZy7A1y8z-W0MQpE"
};